export class ApiHelpers {
  static getOrgDirUrl(env: string | undefined) {
    let portalBaseUrl = 'https://org.laerdal.com';
    if (env === 'dev') portalBaseUrl = 'https://org-dev.laerdal.com';
    else if (env === 'test') portalBaseUrl = 'https://org-test.laerdal.com';
    else if (env === 'preprod') portalBaseUrl = 'https://org-preprod.laerdal.com';
    else if (env === 'local') portalBaseUrl = 'https://localhost:8001';
    return portalBaseUrl;
  }

  static getConnectUrl(env: string | undefined) {
    let portalBaseUrl = 'https://connect.laerdal.com';
    if (env === 'dev') portalBaseUrl = 'https://connect-dev.laerdal.com';
    else if (env === 'test') portalBaseUrl = 'https://connect-test.laerdal.com';
    else if (env === 'preprod') portalBaseUrl = 'https://connect-preprod.laerdal.com';
    else if (env === 'local') portalBaseUrl = 'https://localhost:5001';
    return portalBaseUrl;
  }
}
